/* LucyBalu MW 21.10.26: Preisanzeige (snippets/lb-price-savings.liquid)
   1. Produktseite: Preiszeile bei Variantenwechsel aktualisieren (Daten aus dem JSON im Snippet)
   2. Platzprüfung [data-lb-fit]:
      Produktseite – passt die Zeile nicht, fällt „Du sparst:“ weg (lb-short), erst danach Umbruch (lb-wrap)
      Kachel – passt die Ersparnis nicht in die Zeile, fällt sie weg (lb-nochip), erst danach Umbruch (lb-wrap) */
(function () {
  if (window.lbPriceReady) return;
  window.lbPriceReady = true;

  function over(el) { return el.scrollWidth > el.clientWidth + 1; }

  function fit(el) {
    el.classList.remove('lb-short', 'lb-nochip', 'lb-wrap');
    if (!el.clientWidth || !over(el)) return;
    el.classList.add(el.classList.contains('lb-tp') ? 'lb-nochip' : 'lb-short');
    if (over(el)) el.classList.add('lb-wrap');
  }

  // Breitenänderung (Drehen, Slider, eingeblendete Tabs) → neu prüfen
  var ro = 'ResizeObserver' in window ? new ResizeObserver(function (entries) {
    entries.forEach(function (en) {
      var w = Math.round(en.contentRect.width);
      if (String(w) === en.target.dataset.lbW) return; // nur Breite zählt (Umbruch ändert die Höhe)
      en.target.dataset.lbW = w;
      fit(en.target);
    });
  }) : null;

  function fitAll(root) {
    (root || document).querySelectorAll('[data-lb-fit]').forEach(function (el) {
      if (ro && !el.dataset.lbRo) { el.dataset.lbRo = '1'; ro.observe(el); }
      fit(el);
    });
  }

  // Produktseite: Variante wechseln
  function initPdp(box) {
    if (box.dataset.lbInit) return;
    box.dataset.lbInit = '1';
    var data = {};
    try { data = JSON.parse(box.querySelector('[data-lb-pp-data]').textContent); } catch (e) { return; }
    var scope = box.closest('.product_section') || document;
    var row = box.querySelector('.lb-pp__row');
    var oldEl = box.querySelector('.lb-pp__old');
    var nowEl = box.querySelector('.lb-pp__now');
    var chip = box.querySelector('.lb-chip');
    var chipV = box.querySelector('.lb-chip__v');
    var note = box.querySelector('.lb-pp__note');

    function show(id) {
      var d = data[String(id)];
      if (!d) return;
      nowEl.textContent = d.p;
      oldEl.textContent = d.s;
      oldEl.hidden = !d.s;
      chipV.textContent = d.c;
      chip.hidden = !d.c;
      note.innerHTML = d.n;
      note.hidden = !d.n;
      fit(row);
    }

    document.addEventListener('variant-change', function (e) {
      var v = (e.detail || {}).variant;
      if (!v || !v.id) return;
      if (scope !== document && !scope.contains(e.target)) return;
      show(v.id);
    }, true);
    scope.addEventListener('change', function () {
      setTimeout(function () {
        var input = scope.querySelector('[name="id"]');
        if (input && input.value) show(input.value);
      }, 50);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-lb-pp]').forEach(initPdp);
    fitAll();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { fitAll(); });

  if (!ro) {
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fitAll, 120); });
  }

  // Nachgeladene Kacheln (Filter, Slider, Quick-Shop, Theme-Editor)
  var pending = false;
  new MutationObserver(function (list) {
    if (pending) return;
    for (var i = 0; i < list.length; i++) {
      var nodes = list[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var n = nodes[j];
        if (n.nodeType === 1 && (n.matches('[data-lb-fit],[data-lb-pp]') || n.querySelector('[data-lb-fit],[data-lb-pp]'))) {
          pending = true;
          requestAnimationFrame(function () { pending = false; initAll(); });
          return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
